/**
 * Credit Note Types (Nature Facture d'Avoir) as defined by DGI Burkina Faso
 * Reference: Specifications Techniques SECeF v2.0, Section 7.8
 *
 * These codes define the reason/nature for issuing a credit note (avoir).
 */
/**
 * Credit note types as defined by DGI section 7.8
 */
export const CREDIT_NOTE_TYPES = {
    /**
     * COR - Correction
     * Simple correction of an invoice
     */
    COR: {
        code: "COR",
        label: "Correction",
        description: "Correction simple",
        requiresOriginalInvoice: true,
        returnsGoods: true,
    },
    /**
     * RAN - Annulation
     * Cancellation without return of goods or services
     */
    RAN: {
        code: "RAN",
        label: "Annulation",
        description: "Annulation sans retour de marchandises ou de services",
        requiresOriginalInvoice: true,
        returnsGoods: false,
    },
    /**
     * RAM - Avoir suite reprise
     * Correction or cancellation after payment or delivery
     */
    RAM: {
        code: "RAM",
        label: "Avoir suite reprise",
        description: "Correction ou annulation après paiement ou livraison",
        requiresOriginalInvoice: true,
        returnsGoods: true,
    },
    /**
     * RRR - Remise, ristourne, rabais
     * Commercial discount (rebate, volume discount, promotional discount).
     * DGI §2.29: recorded on a credit note whose original-invoice reference
     * is the literal "RRR", so no original invoice is required.
     */
    RRR: {
        code: "RRR",
        label: "Remise, ristourne, rabais",
        description: "Remise commerciale",
        requiresOriginalInvoice: false,
        returnsGoods: false,
    },
};
/**
 * Get credit note type by code
 * @param code - The credit note type code (COR, RAN, RAM, RRR)
 * @returns The credit note type configuration
 */
export function getCreditNoteType(code) {
    return CREDIT_NOTE_TYPES[code];
}
/**
 * Check if a string is a valid credit note type code
 * @param code - The code to validate
 * @returns true if the code is a valid credit note type code
 */
export function isValidCreditNoteType(code) {
    if (typeof code !== "string") {
        return false;
    }
    return code in CREDIT_NOTE_TYPES;
}
/**
 * Whether a credit note of nature `code` returns goods or services (A report,
 * SFE §5.2 f), read from `CREDIT_NOTE_TYPES`. A credit note with no nature,
 * or with a nature outside the DGI table, counts as a return.
 */
export function creditNoteReturnsGoods(code) {
    if (!code || !Object.hasOwn(CREDIT_NOTE_TYPES, code))
        return true;
    return CREDIT_NOTE_TYPES[code].returnsGoods;
}
//# sourceMappingURL=credit-note-types.js.map